var map = {
	"./blue-check.svg": 196,
	"./blue-copy.svg": 197,
	"./blue-success.svg": 121,
	"./colored-bell-alert.svg": 107,
	"./colored-email.svg": 122,
	"./colored-hourglass.svg": 123,
	"./colored-lock.svg": 124,
	"./email-white.svg": 198,
	"./grey-tooltip.svg": 108,
	"./messenger-white.svg": 199,
	"./referral.svg": 125,
	"./telegram-white.svg": 200,
	"./whatsapp-white.svg": 201,
	"./white-alert.svg": 109,
	"./white-check.svg": 110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 120;